import SetAccessGroupButton from './SetAccessGroupButton';

export default SetAccessGroupButton;
